import { defineMessages } from 'react-intl';

const messages = defineMessages({
  slackChannel: {
    id: 'IntegrationsSettings.SlackChannel',
    defaultMessage: 'Channel Name',
  },
  channelRequired: {
    id: 'IntegrationsSettings.SlackChannelRequired',
    defaultMessage: 'Channel name is required.',
  },
  surveysRequired: {
    id: 'IntegrationsSettings.SlackSurveysRequired',
    defaultMessage: 'Please select some surveys.',
  },
  channelFormat: {
    id: 'IntegrationsSettings.SlackChannelFormat',
    defaultMessage:
      'Channel names can only contain lowercase letters, numbers, hyphens, and underscores, and must be 80 characters or less.',
  },
  surveys: {
    id: 'IntegrationsSettings.SlackSurveys',
    defaultMessage: 'Surveys',
  },
  condition: {
    id: 'IntegrationsSettings.SlackCondition',
    defaultMessage: 'Condition',
  },
  addRule: {
    id: 'IntegrationsSettings.SlackAddRule',
    defaultMessage: 'Add a new rule',
  },
  conditionAllAll: {
    id: 'IntegrationsSettings.ConditionAllAll',
    defaultMessage: 'All responses',
  },
  conditionCommentedAll: {
    id: 'IntegrationsSettings.ConditionCommentedAll',
    defaultMessage: 'Only responses with comments',
  },
  conditionAllPromoters: {
    id: 'IntegrationsSettings.ConditionAllPromoters',
    defaultMessage: 'All "Satisfied"',
  },
  conditionCommentedPromoters: {
    id: 'IntegrationsSettings.ConditionCommentedPromoters',
    defaultMessage: 'Only "Satisfied" with comments',
  },
  conditionAllPassives: {
    id: 'IntegrationsSettings.ConditionAllPassives',
    defaultMessage: 'All "Neutral"',
  },
  conditionCommentedPassives: {
    id: 'IntegrationsSettings.ConditionCommentedPassives',
    defaultMessage: 'Only "Neutral" with comments',
  },
  conditionAllDetractors: {
    id: 'IntegrationsSettings.ConditionAllDetractors',
    defaultMessage: 'All "Dissatisfied"',
  },
  conditionCommentedDetractors: {
    id: 'IntegrationsSettings.ConditionCommentedDetractors',
    defaultMessage: 'Only "Dissatisfied" with comments',
  },
  all: {
    id: 'IntegrationsSettings.All',
    defaultMessage: 'All',
  },
  edit: {
    id: 'IntegrationsSettings.Edit',
    defaultMessage: 'Edit',
  },
  remove: {
    id: 'IntegrationsSettings.Remove',
    defaultMessage: 'Remove',
  },
  cancel: {
    id: 'Confirm.Cancel',
    defaultMessage: 'Cancel',
  },
  save: {
    id: 'Confirm.Save',
    defaultMessage: 'Save',
  },
  disabled: {
    id: 'IntegrationsSettings.SlackDisabled',
    defaultMessage: 'Disabled',
  },
  enabled: {
    id: 'IntegrationsSettings.SlackEnabled',
    defaultMessage: 'Enabled',
  },
  enableDisableRule: {
    id: 'IntegrationsSettings.SlackEnableDisableRule',
    defaultMessage: 'Enable/Disable this rule',
  },
  refreshChannels: {
    id: 'IntegrationsSettings.SlackRefreshChannels',
    defaultMessage: 'Refresh channels',
  },
  startingSync: {
    id: 'IntegrationsSettings.SlackStartingSync',
    defaultMessage: 'Starting sync...',
  },
  channelNameHelper: {
    id: 'IntegrationsSettings.SlackChannelNameHelper',
    defaultMessage: 'Enter channel name (e.g., #general or general)',
  },
  channelPlaceholder: {
    id: 'IntegrationsSettings.SlackChannelPlaceholder',
    defaultMessage: '#channel-name',
  },
  channelListUnavailable: {
    id: 'IntegrationsSettings.SlackChannelListUnavailable',
    defaultMessage: 'Note: Channel list unavailable. Please enter the channel name manually.',
  },
  syncingChannels: {
    id: 'IntegrationsSettings.SlackSyncingChannels',
    defaultMessage: 'Syncing channels in background...',
  },
  requestCompleted: {
    id: 'IntegrationsSettings.SlackRequestCompleted',
    defaultMessage: '{count} channels fetched so far',
  },
  thisMayTakeTime: {
    id: 'IntegrationsSettings.SlackThisMayTakeTime',
    defaultMessage: 'This may take several minutes for large workspaces.',
  },
  missingPermissions: {
    id: 'IntegrationsSettings.SlackMissingPermissions',
    defaultMessage:
      'Channel list unavailable due to missing permissions. Please enter channel names manually.',
  },
  syncFailed: {
    id: 'IntegrationsSettings.SlackSyncFailed',
    defaultMessage: 'Sync failed. Please try refreshing.',
  },
  lastUpdate: {
    id: 'IntegrationsSettings.SlackLastUpdate',
    defaultMessage: 'Last update: {date} ({count} channels)',
  },
  loadingChannels: {
    id: 'IntegrationsSettings.SlackLoadingChannels',
    defaultMessage: 'Loading channels...',
  },
  typeToSearch: {
    id: 'IntegrationsSettings.SlackTypeToSearch',
    defaultMessage: 'Type to search channels...',
  },
  privateChannel: {
    id: 'IntegrationsSettings.SlackPrivateChannel',
    defaultMessage: '(Private)',
  },
  loading: {
    id: 'IntegrationsSettings.SlackLoading',
    defaultMessage: 'Loading...',
  },
  noChannelsFound: {
    id: 'IntegrationsSettings.SlackNoChannelsFound',
    defaultMessage: 'No channels found',
  },
  reauthorize: {
    id: 'IntegrationsSettings.SlackReauthorize',
    defaultMessage: 'Reauthorize Slack connection',
  },
});

export default messages;
